import compose from './compose'

export const addItem = (list, item) => [...list, item]

export const removeItem = (list, id) => list.filter(item => item.id !== id)

const toNumber = (list) => list.map(item => Number(item))

const makeArrayIfString = (node) => {
  if (typeof node === 'string') {
    return [node]
  }

  return node
}

export const sanitizeFilter = compose(
  toNumber,
  makeArrayIfString
)



// WEBPACK FOOTER //
// ./src/utils/filters.js